import { useTranslation } from "react-i18next"

/** Cùng độ rộng nội dung 114rem với trang common (/dich-vu-visa, xem .visa trong _visa.scss:
 * max-width: calc($page-width + $page-padding-inline * 2) = calc(114rem + 3rem)) — dùng chung
 * cho trang chi tiết (VisaDetailPage) và trang kết quả tìm kiếm (VisaSearchResultsClient) để
 * cả 3 trang trong module visa luôn cùng 1 độ rộng, tránh lệch khi sửa riêng từng file. */
export const VISA_CONTENT_COL_PROPS = { xs: 24, sm: 24, lg: 17, xl: 16, xxl: { flex: "114rem" } } as const

/** Thứ tự nhóm giấy tờ hiển thị trên trang chi tiết. */
export const VISA_DOCUMENT_GROUP_ORDER = ["PERSONAL", "FINANCIAL", "EMPLOYMENT", "TRIP", "OTHER"] as const

export const useVisaCategoryLabel = (): Record<string, string> => {
  const { t } = useTranslation()
  return {
    TOURISM: t("visa.category.tourism"),
    BUSINESS: t("visa.category.business"),
    FAMILY: t("visa.category.family"),
    STUDY: t("visa.category.study"),
    TRANSIT: t("visa.category.transit"),
    OTHER: t("visa.category.other"),
  }
}

export const useVisaCategoryOptions = () => {
  const label = useVisaCategoryLabel()
  return [
    { value: "TOURISM", label: label.TOURISM },
    { value: "FAMILY", label: label.FAMILY },
    { value: "BUSINESS", label: label.BUSINESS },
    { value: "STUDY", label: label.STUDY },
    { value: "TRANSIT", label: label.TRANSIT },
    { value: "OTHER", label: label.OTHER },
  ] as const
}

export const useVisaContactChannelOptions = () => {
  const { t } = useTranslation()
  return [
    { value: "PHONE", label: t("visa.contact_channel.phone") },
    { value: "ZALO", label: t("visa.contact_channel.zalo") },
    { value: "EMAIL", label: t("visa.contact_channel.email") },
  ] as const
}

/** entryType có thể null — chương trình không nêu rõ, phụ thuộc kết quả xét duyệt của ĐSQ. */
export const useVisaEntryTypeLabel = (): Record<string, string> => {
  const { t } = useTranslation()
  return {
    SINGLE: t("visa.entry_type.single"),
    MULTIPLE: t("visa.entry_type.multiple"),
  }
}

export const useVisaApplicationMethodLabel = (): Record<string, string> => {
  const { t } = useTranslation()
  return {
    EVISA: t("visa.application_method.evisa"),
    EMBASSY: t("visa.application_method.embassy"),
    VISA_CENTER: t("visa.application_method.visa_center"),
    AGENCY: t("visa.application_method.agency"),
  }
}

export const useVisaApplicationMethodOptions = () => {
  const label = useVisaApplicationMethodLabel()
  return [
    { value: "EVISA", label: label.EVISA },
    { value: "EMBASSY", label: label.EMBASSY },
    { value: "VISA_CENTER", label: label.VISA_CENTER },
    { value: "AGENCY", label: label.AGENCY },
  ] as const
}

export const useVisaDocumentGroupLabel = (): Record<string, string> => {
  const { t } = useTranslation()
  return {
    PERSONAL: t("visa.document_group.personal"),
    EMPLOYMENT: t("visa.document_group.employment"),
    FINANCIAL: t("visa.document_group.financial"),
    TRIP: t("visa.document_group.trip"),
    OTHER: t("visa.document_group.other"),
  }
}

export const useVisaApplicantTypeLabel = (): Record<string, string> => {
  const { t } = useTranslation()
  return {
    EMPLOYEE: t("visa.applicant_type.employee"),
    BUSINESS_OWNER: t("visa.applicant_type.business_owner"),
    STUDENT: t("visa.applicant_type.student"),
    CHILD: t("visa.applicant_type.child"),
    RETIRED: t("visa.applicant_type.retired"),
    FREELANCER: t("visa.applicant_type.freelancer"),
    ALL: t("visa.applicant_type.all"),
  }
}
